import { createSlice } from "@reduxjs/toolkit";
import {
  GetUserData,
  UserInitialStatus,
  ViewUserData,
  ChatRoom,
} from "../../../../types/csoManager/user";
import {
  createUserAsync,
  getAllUserAsync,
  singUserDataAsync,
  updateUserDataAsync,
  getAllRooms,
} from "./userApi";

interface UserState {
  roomList: {
    data: ChatRoom[];
    length: number;
  };
  loading: boolean;
  manageLoading: boolean;
  userList: GetUserData[];
  singleUserData: ViewUserData | null;
  countUser: number;
}

const initialState: UserState = {
  roomList: {
    data: [],
    length: 0
  },
  loading: false,
  manageLoading: false,
  userList: [],
  singleUserData: null,
  countUser: 0,
};

const csoUserSlice = createSlice({
  name: "admin-csoUser",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // create
    builder
      .addCase(createUserAsync.pending, (state) => {
        state.manageLoading = true;
      })
      .addCase(createUserAsync.fulfilled, (state) => {
        state.manageLoading = false;
      })
      .addCase(createUserAsync.rejected, (state) => {
        state.manageLoading = false;
      });

    // get all
    builder
      .addCase(getAllUserAsync.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getAllUserAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.userList = action.payload.data;
        state.countUser = action.payload.length;
      })
      .addCase(getAllUserAsync.rejected, (state) => {
        state.loading = false;
        state.userList = [];
        state.countUser = 0;
      });

    // update
    builder
      .addCase(updateUserDataAsync.pending, (state) => {
        state.manageLoading = true;
      })
      .addCase(updateUserDataAsync.fulfilled, (state) => {
        state.manageLoading = false;
      })
      .addCase(updateUserDataAsync.rejected, (state) => {
        state.manageLoading = false;
      });

    // single
    builder
      .addCase(singUserDataAsync.pending, (state) => {
        state.manageLoading = true;
        state.singleUserData = null;
      })
      .addCase(singUserDataAsync.fulfilled, (state, action) => {
        state.manageLoading = false;
        state.singleUserData = action.payload;
      })
      .addCase(singUserDataAsync.rejected, (state) => {
        state.manageLoading = false;
        state.singleUserData = null;
      });

    builder
      .addCase(getAllRooms.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllRooms.fulfilled, (state, action) => {
        state.loading = false;
        state.roomList = {
          data: action.payload.data,
          length: action.payload.length
        };
      })
      .addCase(getAllRooms.rejected, (state) => {
        state.loading = false;
        state.roomList = {
          data: [],
          length: 0
        };
      });
  },
});

export default csoUserSlice;
